import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { fetchWithToken } from "../../../functions/fetch";
import { useUpdateTimeSlot } from "../../../contexts/updateTimeSlotContext";

const TimeSlot = ({
  reservation,
  reservable,
  timeText,
  index,
  onOpen,
  setDeletingReservation,
}) => {
  // NOTE: doesn't fetch after change state, only change appearance(localReservable)
  const [localReservable, setLocalReservable] = useState(reservable);
  const [date, setDate] = useState("");
  const [hour, setHour] = useState(0);

  const reserved = reservation !== null;

  const { setUpdateTimeSlot } = useUpdateTimeSlot();

  const minToHour = (min) => {
    return Math.round((min / 60) * 10) / 10;
  };

  // calculate start and end time
  useEffect(() => {
    const todayMidnight = DateTime.local().startOf("day");
    const date = todayMidnight.plus({ day: index });

    const timeNumbers = timeText.match(/\d\d/g).map((str) => Number(str));

    setDate(date.toISO());
    setHour(timeNumbers[0] + minToHour(timeNumbers[1]));
  }, []);

  const toggleReservable = async () => {
    if (reserved) {
      setDeletingReservation(reservation);
      onOpen();
      return;
    }

    const newCanBeReserved = !localReservable;
    // update the canBeReserved of timeSlot

    const formBody = {
      date,
      hour,
      canBeReserved: newCanBeReserved ? "1" : "0",
    };

    const res = await fetchWithToken(
      "PUT",
      `${process.env.REACT_APP_BACKEND_HOST}/api/time-slot`,
      formBody,
    );

    if (res.status === 200) {
      setLocalReservable(newCanBeReserved);
      setUpdateTimeSlot(true);
      return true;
    } else {
      console.error(res);
    }
  };

  return (
    <button
      onClick={toggleReservable}
      className={`p-2 ${reserved ? "bg-custom-orange" : localReservable ? "bg-white" : "bg-custom-dark-gray"} hover:brightness-90`}
    />
  );
};

export default TimeSlot;
